const ecosystem = {
  agents: [
    { role: 'PM', work: 'Shapes requirements and sprint scope', state: 'planning' },
    { role: 'Tech Lead', work: 'Turns goals into architecture', state: 'routing' },
    { role: 'Frontend', work: 'Builds websites and display layers', state: 'rendering' },
    { role: 'Backend', work: 'Designs APIs and durable services', state: 'wiring' },
    { role: 'QA', work: 'Runs checks, screenshots, and regressions', state: 'watching' },
    { role: 'DevOps', work: 'Prepares deploys, CI, and hosting', state: 'staging' },
    { role: 'UX', work: 'Tunes the experience for humans', state: 'polishing' },
    { role: 'Retro', work: 'Captures lessons back into memory', state: 'learning' }
  ],
  workstreams: [
    { name: 'OpenClaw Dashboard', detail: 'Showroom display for the agent ecosystem', progress: 72 },
    { name: 'Website Foundry', detail: 'Future sites, apps, and launch surfaces', progress: 44 },
    { name: 'Scrum Team Ops', detail: 'Role packets, reports, retros, and status', progress: 61 },
    { name: 'Skill System', detail: 'Reusable workflows for faster launches', progress: 38 }
  ],
  pipeline: ['Intake', 'Plan', 'Fan Out', 'Build', 'Verify', 'Ship', 'Learn'],
  scrumctl: [
    { command: 'plan', output: 'Create sprint packets from requirements' },
    { command: 'run-all', output: 'Send work through PM, leads, builders, QA' },
    { command: 'show', output: 'Project reports onto the dashboard' },
    { command: 'retro', output: 'Fold lessons back into future runs' }
  ],
  builds: [
    { name: 'Portfolio Site', status: 'queued', next: 'Generate IA and landing shell' },
    { name: 'Client Demo', status: 'scoping', next: 'Confirm API surface and deploy target' },
    { name: 'Dashboard Display', status: 'verifying', next: 'Review Playwright screenshots' }
  ],
  evidence: [
    { name: 'Line Rule', state: 'passing', detail: 'All source files <= 50 lines' },
    { name: 'React Tests', state: 'passing', detail: 'Main display contract covered' },
    { name: 'API Tests', state: 'passing', detail: 'Ecosystem builds endpoint validates' },
    { name: 'Screenshots', state: 'ready', detail: 'Desktop and mobile Playwright captures' }
  ],
  signals: ['[ready] Claude is orchestrating the workspace.', '[queue] Subagents staged for website builds.', '[scrumctl] sprint reports feeding display contracts.']
};

export default ecosystem;
